import React from 'react';

interface TransactionsIconProps {
  className?: string;
}

const TransactionsIcon: React.FC<TransactionsIconProps> = ({ className = '' }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3 2h10a1 1 0 011 1v10a1 1 0 01-1 1H3a1 1 0 01-1-1V3a1 1 0 011-1z" stroke="currentColor" strokeWidth="1" fill="none"/>
    <path d="M5 6h6M5 8h6M5 10h4" stroke="currentColor" strokeWidth="1"/>
  </svg>
);

export default TransactionsIcon;